import React from 'react';
import ReactTable from 'react-table';
import { CustomPagination } from './common-react-table';
import { _generateTableColumns } from './table-helpers';

// Custom React Table component for CLIENT-SIDE pagination
export const ClientSidePaginatedCFTable = ({
    totalCount,
    resizable,
    columns,
    filterable,
    sortable,
    data,
    defaultSortAsc,
    defaultSortAccessor,
    showFilterBar,
    className,
    pageSize,
  }) => {

  let filterBar = '';
  if (!filterable && showFilterBar) filterBar = 'mock-filter-bar';
  
  let defaultClassName = `cf-reacttable -striped -highlight ${filterBar}`;
  
  let defaultSorted = [];
  if (defaultSortAsc != null && defaultSortAccessor != null) {
    defaultSorted.push({desc: defaultSortAsc, id: defaultSortAccessor});
  }

  const parsedColumns = _generateTableColumns(columns, {}, data.length);
  const filterMethod = ({ pivotId, id, value }, row) => {
    let filterRow = String(pivotId ? row[pivotId] : row[id]);
    if (filterRow === 'undefined') return true;

    return (new RegExp(value, 'i')).test(filterRow);
  }
  
  return (
    <ReactTable
      data={data}
      columns={parsedColumns}
      className={className ? `${defaultClassName} ${className}`: defaultClassName}
      filterable={filterable}
      sortable={sortable}
      defaultSorted={defaultSorted}
      showPageSizeOptions={false}
      defaultPageSize={pageSize}
      defaultFilterMethod={(filter, row) => filterMethod(filter, row)}
      minRows={1}
      resizable={resizable === undefined ? true : resizable}
      totalRecords={totalCount}
      PaginationComponent={CustomPagination}
    />
  );
};



// WEBPACK FOOTER //
// ./src/table/client-side-paginated-react-table.js